export const PZ_TICKETS_ENUM = {
  serviceTicket: "Service Tickets",
  changeStatus: "Change Status",
};
